import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ri-resolution-ui-access-request',
  imports: [],
  templateUrl: './access-request.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessRequestComponent {
  private readonly router = inject(Router);

  public accountId = {
    SourceSystemId: '',
    PartitionId: '',
    HealthSystemId: '',
    AccountNumber: '',
  };

  constructor() {
    const navState =
      this.router.getCurrentNavigation()?.extras?.state?.['accountId'];
    if (navState) {
      this.accountId = {
        SourceSystemId: navState.SourceSystemId ?? '',
        PartitionId: navState.PartitionId ?? '',
        HealthSystemId: navState.HealthSystemId ?? '',
        AccountNumber: navState.AccountNumber ?? '',
      };
    }
  }
}
